import React from 'react'
import styled from 'styled-components'
import Box from './hero-con-box-rojo'
import Multicanalidad from '../botones/multicanalidad'

const Title = styled.div`
  color #fff;
  font-size: 30px;
  margin-bottom: 30px;
`

export default ({ heroImage, title, formUrl, multicanalidad }) => {
  return (
    <Box imagen={heroImage} contentful>
      <Title>{title}</Title>
      <Multicanalidad multicanalidad={multicanalidad} formulario={formUrl} />
    </Box>
  )
}
